import { render, staticRenderFns } from "./TeachOtoTable.vue?vue&type=template&id=26233c5e&scoped=true&"
import script from "./TeachOtoTable.vue?vue&type=script&lang=js&"
export * from "./TeachOtoTable.vue?vue&type=script&lang=js&"
import style0 from "./TeachOtoTable.vue?vue&type=style&index=0&id=26233c5e&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "26233c5e",
  null
  
)

export default component.exports